/* @flow */
import { all } from 'redux-saga/effects';
import authenticationSaga from './AuthenticationSaga';
import agenciesSaga from './AgenciesSaga';
import contractorsSaga from './ContractorsSaga';
import visitsSaga from './VisitsSaga';
import documentsSaga from './DocumentsSaga';
import dashboardSaga from "./DashboardSaga";
import verificationSaga from "./VerificationSaga";

export default function* root(): Generator<*, *, *> {
  yield all([
    ...authenticationSaga,
    ...agenciesSaga,
    ...contractorsSaga,
    ...visitsSaga,
    ...documentsSaga,
    ...dashboardSaga,
    ...verificationSaga,
  ]);
}
